import PubSub from 'pubsub-js'

export default PubSub
